// extracted by mini-css-extract-plugin
module.exports = {"communityContainer":"Community_communityContainer__OYaf4","icons":"Community_icons__0VjP9","iconContainer":"Community_iconContainer__xIV_a","text":"Community_text__1zPz3"};